/* hcx-float-dodge.js (2026-09-22, Raji — audit parcours client mobile)
   La pastille « -10 % » (#hcx-bv-tab) et le bouton retour en haut (#btt-global) recouvraient des cibles importantes :
   « Ajouter au panier » de la fiche, « Voir mes harnais » et « Je n'ai pas de mètre ruban » de l'outil de taille.
   Chaque flottant s'efface (classe .hcx-dodge : opacité 0, non cliquable) tant qu'un bouton, un lien ou un champ de la page
   se trouve sous lui, et revient dès que la zone est libre. Mesure par elementsFromPoint sur 5 points du flottant. */
(function () {
  var FLOATS = ['#hcx-bv-tab', '#btt-global'];
  var CIBLES = 'button, a[href], input, select, textarea, summary, label, [role="button"]';
  var raf = null;
  function recouvre(f) {
    var r = f.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var pts = [[r.left + 6, r.top + 6], [r.right - 6, r.top + 6], [r.left + 6, r.bottom - 6], [r.right - 6, r.bottom - 6], [(r.left + r.right) / 2, (r.top + r.bottom) / 2]];
    for (var i = 0; i < pts.length; i++) {
      var pile = document.elementsFromPoint(pts[i][0], pts[i][1]);
      for (var k = 0; k < pile.length; k++) {
        var e = pile[k];
        if (f.contains(e) || FLOATS.some(function (s) { var o = document.querySelector(s); return o && o.contains(e); })) continue;
        var cible = e.closest && e.closest(CIBLES);
        /* Onglet vertical −10 % (bord droit, 32 px) : il ne cède la place qu'aux PETITES commandes (flèche de galerie, pastille,
           lien court). Un bouton pleine largeur n'est recouvert que sur ses derniers pixels et reste cliquable. */
        if (cible && f.id === 'hcx-bv-tab' && cible.getBoundingClientRect().width > 160) continue;
        if (cible) return true;
      }
    }
    return false;
  }
  function verifier() {
    raf = null;
    FLOATS.forEach(function (s) { var f = document.querySelector(s); if (f) f.classList.toggle('hcx-dodge', recouvre(f)); });
  }
  function planifier() { if (!raf) raf = requestAnimationFrame(verifier); }
  window.addEventListener('scroll', planifier, { passive: true });
  window.addEventListener('resize', planifier);
  document.addEventListener('click', function () { setTimeout(planifier, 350); }, true);
  setInterval(planifier, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', planifier); else planifier();
})();
